import React, { useEffect } from "react";
import { OAuthProvider } from "@nestcoinco/hyper-api-gateway-api-client";

import CheckMarkSuccessful from "../../../images/checkmark_successful.svg";
import DefaultOnboardingStatusPage from "../../ReusablePages/DefaultOnboardingStatusPage/DefaultOnboardingStatusPage";
import {
  registerIdentityEvent,
  registerTrackingEvent,
  getCurrentUrl,
} from "../../../utils/helpers";
import { getStoredAuthProvider } from "../../../utils/storage";
import { OnboardingSteps, TRACKING_EVENTS } from "../../../utils/constants";
import useAuth from "../../../hooks/useAuth";

function LoginSuccessfulPage() {
  const { userProfile } = useAuth();
  const authProvider = getStoredAuthProvider();

  useEffect(() => {
    if (!userProfile || !authProvider) return;

    const { id, email, firstName, lastName, username } = userProfile;
    registerTrackingEvent({
      name: TRACKING_EVENTS.SUCCESSFUL_WEB_LOGIN,
      payload: {
        user_id: id,
        email: email,
        url: getCurrentUrl(),
      },
    });

    registerTrackingEvent({
      name:
        authProvider === OAuthProvider.GOOGLE
          ? TRACKING_EVENTS.WEB_LOG_IN_WITH_GOOGLE
          : TRACKING_EVENTS.WEB_LOG_IN_WITH_FACEBOOK,
      payload: {
        user_id: id,
        email: email,
        url: getCurrentUrl(),
      },
    });

    registerIdentityEvent(id, {
      name: `${firstName} ${lastName}`,
      email: email,
      username: username,
    });
  }, [authProvider, userProfile]);

  return (
    <DefaultOnboardingStatusPage
      titleText="Login successful"
      secondaryText="You have successfully logged in to Hyper!"
      primaryImage={CheckMarkSuccessful}
      redirectDelay={3000}
      nextStep={OnboardingSteps.FIND_FRIENDS}
    />
  );
}

export default LoginSuccessfulPage;
